import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CalendarClock, ArrowRight } from 'lucide-react';

function SchedulerLinkCard() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/scheduler')}
      className="mt-6 w-full flex items-center justify-between gap-3 rounded-xl bg-white border border-gray-200 shadow-sm p-4 text-left hover:border-orange-200 hover:bg-orange-50/40 transition-colors"
    >
      <span className="flex items-center gap-2 text-sm font-medium text-gray-700">
        <CalendarClock size={18} className="text-orange-500" />
        {t('dashboard.schedulerLink.title')}
      </span>
      <ArrowRight size={16} className="text-gray-400" />
    </button>
  );
}

export default SchedulerLinkCard;